import React from 'react';

import SvgContainer from '../SvgContainer';

const DoubleArrow = () => {
    return (
        <SvgContainer>
            <g clipPath="url(#clip0_9366_56882)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.08173 2.17385L8.8248 7.41021C9.00504 7.60815 9.00504 7.91185 8.8248 8.11084L4.08173 13.3472C3.98054 13.4561 3.8393 13.52 3.68963 13.52H0.527583C0.319942 13.52 0.131273 13.3985 0.0458973 13.209C-0.039478 13.0205 -0.00364146 12.7995 0.135489 12.6455L4.56131 7.76L0.135489 2.87343C-0.00364146 2.72052 -0.038424 2.49955 0.0458973 2.30999C0.131273 2.12148 0.319942 2 0.527583 2H3.68963C3.8393 2 3.98054 2.06284 4.08173 2.17385ZM11.1218 2.17385L15.8648 7.41021C16.0451 7.60815 16.0451 7.91185 15.8648 8.11084L11.1218 13.3472C11.0206 13.4561 10.8793 13.52 10.7297 13.52H7.56762C7.35998 13.52 7.17131 13.3985 7.08594 13.209C7.00056 13.0205 7.0364 12.7995 7.17553 12.6455L11.6013 7.76L7.17553 2.87343C7.0364 2.72052 7.00162 2.49955 7.08594 2.30999C7.17131 2.12148 7.35998 2 7.56762 2H10.7297C10.8793 2 11.0206 2.06284 11.1218 2.17385Z"
                />
            </g>
            <defs>
                <clipPath id="clip0_9366_56882">
                    <rect width="16" height="16" fill="white" />
                </clipPath>
            </defs>
        </SvgContainer>
    );
};

export default DoubleArrow;
